import { UserType } from "@inrev/common";
import {
	useAuthenticatedUser,
	useAuthenticatedUserDispatch,
} from "@portal/providers/AuthenticatedUserProvider";
import { CompleteAccountSetupView } from "@portal/views/agent/setup/CompleteAccountSetupView";
import { AdminApp } from "./AdminApp";
import { AgentApp } from "./AgentApp";

export const AppRouter = () => {
	const { user } = useAuthenticatedUser();
	const { loginWithRedirectAndClose } = useAuthenticatedUserDispatch();

	if (user) {
		if (user.type === UserType.admin) {
			return <AdminApp />;
		}

		if (user.type === UserType.agent) {
			if (user.setupComplete) return <AgentApp />;
			return <CompleteAccountSetupView />;
		}
	}

	loginWithRedirectAndClose();
};
